/* eslint-disable camelcase */
import { formatCurrency } from '@/utils/formatCurrency'
export default {
  computed: {
    lineNumArray () {
      const lineNum = {}
      for (let key = 0; key <= 9; key++) {
        lineNum[key] = []
        for (let j = 0; j <= 9; j++) {
          const degit = key + j + 1 > 9 ? (key + j + 1) % 10 : key + j + 1
          lineNum[key].push(parseInt(`${j}${degit}`))
        }
      }

      return lineNum
    },
    weekDay () {
      return {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
      }
    },
    translBetKeyFunc () { // 翻譯
      return require('@/utils/translBetKeyToI18N/' + this.gameCategory + '.js').default
    }
  },

  methods: {
    addZero (num, oddsKey = '') {
      if (oddsKey.includes('COMBINATION:SP') && num < 10) return `00${num}`
      if (oddsKey.includes('COMBINATION:SP') && num > 9 && num < 100) {
        return `0${num}`
      }
      return num < 10 ? `0${num}` : num.toString()
    },
    getTaiNumSpThree (result) {
      const taiNum = result.filter((num, index) => {
        if (index + 1 < result.length) return num
      })
        .map(num => num[1])
        .reduce((newArray, num, index, array) => {
          if (index + 1 < array.length) newArray.push(num + array[index + 1])
          return newArray
        }, [])

      const spThree = taiNum.filter((num, index) => {
        if (index > 0 && index + 1 < taiNum.length) return num
      })
        .map(num => num[1])
        .reduce((a, b) => [a + b])

      return {
        TaiNum: taiNum,
        SpThree: spThree
      }
    },
    $record_label (label, oddsKey) {
      const firstText = label.split('-')[0]
      const secondText = label.split('-')[1]
      if (['PK10'].includes(this.gameLotto) && ['RankPosition', 'RankTwoSide'].includes(label)) {
        const numKey = oddsKey.split(':')[0]
        return this.$t(`${label}`, { numKey: this.$t(`pk10_${numKey}`) })
      }

      if (['PK10'].includes(this.gameLotto) && firstText.includes('D' || 'T')) {
        return this.$t('RankTwoSide', { numKey: this.$t(`pk10_dragon_tiger`) })
      }

      if (this.gameLotto === 'THAI') {
        return this.$t(`${label}`)
      }

      return secondText && !label.includes('TopThree')
        ? `${this.$t(firstText)} - ${this.$t(secondText)}`
        : this.$t(firstText)
    },
    $odds_label (label) {
      const firstText = label.split('-')[0]
      return this.$t(firstText)
    },
    $record_betItem (data, oddsKey, label) {
      if (data.length) {
        let dataArray = []
        if (label.includes('Pillar') || label.includes('Sky') || label.includes('TopThree')) {
          dataArray = data.map((item, index) => {
            const numArray = item.split(',')
            let title = `${this.$t('pillar_n', { n: index + 1 })}`
            if (label.includes('Sky')) {
              title = index === 0 ? this.$t('SpNum') : this.$t('OfficialNum')
            }
            if (label.includes('SpOfficial')) {
              title = index === 0 ? this.$t('SpNum') : `${this.$t('pillar_n', { n: index })}`
            }
            if (label.includes('Position')) {
              title = this.$t(`pk10_${index + 1}`)
            }
            return {
              title,
              num: numArray.map(num => this.addZero(num, oddsKey))
            }
          })
        } else if (label.includes('Double')) {
          dataArray = data.map((item, index) => {
            const numArray = item.split(',')
            let title = this.$t('DoubleStar_2Bom')
            if (label.includes('StarBom') && index === 1) title = this.$t('ConcatStar_3')

            return {
              title,
              num: numArray.map(num => this.addZero(num, oddsKey))
            }
          })
        } else if (label.includes('Tail')) {
          dataArray.push({ num: data.map(num => `Tail_${num}`) })
        } else if (label.includes('ConcatPass')) {
          dataArray = data.map((item, index) => {
            const numArray = item.split(':')
            return {
              title: this.$t(`${numArray[0]}_Ball`),
              num: [numArray[2]]
            }
          })
        } else {
          dataArray.push({
            num: data.map(num => this.addZero(num, oddsKey))
          })
        }

        return dataArray
      } else {
        const textArray = oddsKey.split(':')
        if (label.includes('BallColor')) {
          return textArray
            .splice(1)
            .toString()
            .replaceAll(',', ':')
        }
        if (label.includes('AllTwoSideAmount')) {
          return `${textArray[1]}_${textArray[2]}Ball`
        }
        if (label.includes('TaiNum') || label.includes('SpThree')) {
          const getLineNum = num => {
            let lineNum = ''
            Object.keys(this.lineNumArray).forEach(key => {
              if (this.lineNumArray[key].includes(parseInt(num))) {
                lineNum = parseInt(key) + 1
              }
            })
            return lineNum
          }
          const num = label === 'TaiNum' ? textArray[1] : textArray[2]
          const firstLineNum = getLineNum(parseInt(parseInt(num) / 10))
          const secondLineNum = getLineNum(parseInt(num) % 100)
          const lineNum =
            label === 'TaiNum' ? getLineNum(num) : firstLineNum + secondLineNum

          return [{
            title: `${this.$t('LineNum')}${lineNum}`,
            num: [this.addZero(num, oddsKey)]
          }]
        }
        if (oddsKey.includes('ZODIAC')) return textArray[textArray.length - 1].toLowerCase()
        if (oddsKey.includes('LOCATE') || oddsKey.includes('MATCH:NL')) return this.addZero(textArray[0], oddsKey)
        if (oddsKey.includes('TAIL')) return `Tail_${textArray[2]}`
        if (oddsKey.includes('OVER')) return 'OVER'
        if (oddsKey.includes('UNDER')) return 'UNDER'
        if (oddsKey.includes('ODD')) return 'ODD'
        if (oddsKey.includes('EVEN')) return 'EVEN'
      }
    },
    $record_calcWinAmount (item, isChaseAmount = false) {
      const { status, total_win_amount, total_bet_amount } = item
      let result
      switch (status) {
        case 1:
        case 7:
        case 12:
        case 13:
          result = formatCurrency(total_win_amount)
          break
        case 2:
        case 4:
        case 5:
          result = '0.00'
          break
        // 和局: 顯示投注金額
        case 6:
          result = formatCurrency(total_bet_amount)
          break
        default:
          result = '-'
      }
      return result
    },
    $record_isWin (item) {
      // 和局也算win
      return item.total_win_amount > 0 || item.status === 6
    },
    $record_orderIdCopy (id) {
      this.isCopy = true

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            this.copyTip = this.$_getBetErrorMsg('30000')
          })
          .catch(() => {
            this.copyTip = this.$_getBetErrorMsg('30001')
          })

        setTimeout(() => {
          this.isCopy = false
        }, 1000)
        return
      }

      const textArea = document.createElement('textarea')

      textArea.value = id
      textArea.style.opacity = 0
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand('copy')
        ? (this.copyTip = this.$_getBetErrorMsg('30000'))
        : (this.copyTip = this.$_getBetErrorMsg('30001'))
      textArea.remove()

      setTimeout(() => {
        this.isCopy = false
      }, 1000)
    }
  }
}
